import { render, staticRenderFns } from "./baoxiu.vue?vue&type=template&id=05e07977&scoped=true&"
import script from "./baoxiu.vue?vue&type=script&lang=js&"
export * from "./baoxiu.vue?vue&type=script&lang=js&"
import style0 from "./baoxiu.vue?vue&type=style&index=0&id=05e07977&lang=less&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e07977",
  null
  
)

export default component.exports